import React from "react"
import { IMG } from "../CONST"
import { useStore } from "../../../stores/RootStoreContext"
import { Link } from "react-router-dom"
import { PROFILE_ROUTE } from "../../../routes"
import { useInstancesStore } from "@/stores/instancesStore"
import { useUnreadStore } from "@/stores/unreadStore"

export const HeaderProfileList: React.FC<{
  visible: boolean
  setVisible: (visible: boolean) => void
  showProfile: () => void
  showPassword: () => void
}> = ({ visible, setVisible, showProfile, showPassword }) => {
  const { userStore } = useStore()
  const resetInstances = useInstancesStore(state => state.resetInstances)
  const resetUnreadList = useUnreadStore(state => state.resetUnreadList)

  const logout = () => {
    userStore.setToken("")
    window.location.href = "/"
    resetInstances()
    resetUnreadList()
  }

  const editPassword = () => {
    setVisible(false)
    showPassword()
  }

  if (visible) {
    return (
      <>
        <ul id="opened_menu_profile" onMouseLeave={() => setVisible(false)}>
          <Link className="menu-profile" id="profile-open" to={PROFILE_ROUTE}>
            <img src={IMG.info} alt="" className="main-header-nav-img" />
            <p className="main-header-item-text">Информация</p>
          </Link>
          <li className="menu-profile" id="password" onClick={editPassword}>
            <img src={IMG.lock_black} alt="" className="main-header-nav-img" />
            <p className="main-header-item-text">Пароль</p>
          </li>
          <li className="menu-profile" id="exit" onClick={() => logout()}>
            <img src={IMG.exit} alt="" className="main-header-nav-img" />
            <p className="main-header-item-text">Выход</p>
          </li>
        </ul>
      </>
    )
  } else {
    return <></>
  }
}
